<template>
<div class="animated fadeIn">

  <b-card no-body>
    <b-card-body fluid="xl">
      <b-row class="text-center">
        <b-col cols="12">
            <h2><b-badge variant="info">Patient Information Form</b-badge></h2>
        </b-col>
      </b-row>
      <b-card>
        <b-row>
          <b-col>
          <b-form-group label="Search" label-for="searchText" label-cols-sm="4" label-cols-lg="3">
            <b-form-input id="searchText" name="searchText"  @blur="searchBlur"  @focus="searchTextFocused" :state="validateState('searchText')"  maxlength="15" aria-describedby="liveFeedbackSearchText"  v-model="$v.form.searchText.$model"  />

            <b-list-group v-if="showListGroup" id="searchTextList">
               <b-list-group-item ref="listIndexes" @keydown="keydownMethod(index)"@keyup="keyupMethod(index)"  @click="searchListClicked(item)" v-for="(item,index) in patients" button  v-bind:key="item.id">{{item.id}} - {{item.name}} - {{item.mobile}}</b-list-group-item>
            </b-list-group>

            <b-form-invalid-feedback id="liveFeedbackSearchText">
               This is a required field.
             </b-form-invalid-feedback>
          </b-form-group>
          </b-col>
          <b-col>
            <b-button-toolbar class="pull-right">
              <b-btn variant="primary"  @click="createNewPatientModal">New Patient</b-btn>
            </b-button-toolbar>
            </b-col>
             </b-row>
          </b-card>

          <div>
            <b-modal ref="modalNewPatient" title="Add New Patient" hide-footer >
              <new-patient-form  @success="addNewPatientModalSuccess" @cancel="cancelNewPatientModal" />
            </b-modal>
          </div>



      <b-form @submit.stop.prevent="onSubmit">

       <b-row>
         <b-col>
         <b-form-group label="Name" label-for="name" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="name" :state="validateState('name')" name="name"   aria-describedby="liveFeedbackName"  v-model.lazy.trim="$v.form.name.$model" readonly/>
           <b-form-invalid-feedback id="liveFeedbackName">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
         <b-form-group label="Father Name" label-for="fatherName" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="fatherName" :state="validateState('fatherName')" name="fatherName"   aria-describedby="liveFeedbackFatherName"  v-model.lazy.trim="$v.form.fatherName.$model" readonly/>
           <b-form-invalid-feedback id="liveFeedbackFatherName">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
         <b-form-group label="Address" label-for="address" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="address" :state="validateState('address')" name="address"   aria-describedby="liveFeedbackAddress"  v-model.lazy.trim="$v.form.address.$model" readonly/>
           <b-form-invalid-feedback id="liveFeedbackAddress">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
         <b-form-group label="Phone Number" label-for="phone" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="phone" :state="validateState('phone')" name="phone"   aria-describedby="liveFeedbackPhone"  v-model.lazy.trim="$v.form.phone.$model" readonly/>
           <b-form-invalid-feedback id="liveFeedbackPhone">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
         <b-form-group label="Symptoms" label-for="symptom" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="symptom" :state="validateState('symptom')" name="symptom"   aria-describedby="liveFeedbackSymptom"  v-model.lazy.trim="$v.form.symptom.$model" />
           <b-form-invalid-feedback id="liveFeedbackSymptom">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
         <b-form-group label="Diagnoses" label-for="diagnoses" label-cols-sm="4" label-cols-lg="3">
           <b-form-input id="diagnoses" :state="validateState('diagnoses')" name="diagnoses"   aria-describedby="liveFeedbackDiagnoses"  v-model.lazy.trim="$v.form.diagnoses.$model" />
           <b-form-invalid-feedback id="liveFeedbackDiagnoses">
              This is a required field.
            </b-form-invalid-feedback>
         </b-form-group>
         </b-col>
       </b-row>
       <b-row>
         <b-col>
           <b-form-group label="Treatments" label-for="treatments" label-cols-sm="4" label-cols-lg="3">
             <b-input-group id="treatments" name="treatments">
               <b-input-group-prepend>
                 <b-button variant="outline-info" @click="removeTreatment">Remove Treatment</b-button>
               </b-input-group-prepend>
               <b-form-input v-model="numberOfTreatments" disabled></b-form-input>
               <b-input-group-append>
                 <b-button variant="success" @click="addTreatment">Add Treatment</b-button>
               </b-input-group-append>
             </b-input-group>
           </b-form-group>
          <b-form-group label="" label-for="" label-cols-sm="4" label-cols-lg="3">
            <treatment-list ref="treatmentList"></treatment-list>
          </b-form-group>
         </b-col>
       </b-row>
      </b-form>
    </b-card-body>
  </b-card>
</div>
</template>


<script>
import Vue from 'vue'
import { validationMixin } from "vuelidate";
import { required, minLength,numeric, minValue, maxLength, email,alpha,helpers } from "vuelidate/lib/validators";

import TreatmentList from './TreatmentList'
import NewPatientForm from './NewPatientForm'
const formShape = {
  searchText: null,
  name: null,
  fatherName: null,
  address: null,
  phone: null,
  symptom: null,
  diagnoses : null,
  id: null
}
export default {
name: 'PatientEnryForm',
components: {
  TreatmentList,
  NewPatientForm
},

data: function() {
  return {
    form: Object.assign({}, formShape),
    selectedSearchOption : false,
    patients: [],
    numberOfTreatments: 0
  }
},
validations: {
  form: {
    searchText: {
      required
    },
    name: {
      required
    },
    fatherName: {
      required
    },
    address: {
      required
    },
    phone: {
      required
    },
    symptom: {
      required
    },
    diagnoses: {
      required
    },
  }
},

watch: {

  'form.searchText': function(value){
    let params = {"searchText": value};
    if(value != null && value.length >= 5 && this.selectedSearchOption == false){
      this.$store.dispatch('dispensary/getPatientByIdMobileName', params)
        .then((response) => {
              this.patients = response.data.data;
        })
        .catch((error) => {
        });
    }

  }
},
methods: {
  createNewPatientModal(){
    this.$refs.modalNewPatient.show();
  },
  cancelNewPatientModal() {
    this.$refs.modalNewPatient.hide();
  },
  addNewPatientModalSuccess(patientInfo) {
    this.$refs.modalNewPatient.hide();
    this.searchListClicked(patientInfo);
  },
  addTreatment() {
    if (this.numberOfTreatments < 20) {
      this.numberOfTreatments++
      this.$refs.treatmentList.addTreatment()
    }
  },
  removeTreatment() {
    if (this.numberOfTreatments > 0) {
      this.numberOfTreatments--
      this.$refs.treatmentList.removeTreatment()
    }
  },
  createPatientModal(){

  },
  validateState(name) {
    const { $dirty, $error } = this.$v.form[name];
    return $dirty ? !$error : null;
  },
  showListGroup : function(){
    var strSearchText = '' + this.form.searchText;
    return (this.patients.length > 0 && this.selectedSearchOption === false && strSearchText.length >= 5)
  },
  searchBlur(){
    if(this.showListGroup == true && event.relatedTarget.parentNode != null && event.relatedTarget.parentNode.id !='searchTextList' ){
     this.selectedSearchOption = true;
    }
  },
  searchTextFocused(){
      this.selectedSearchOption = false;
  },
  keydownMethod(index){
    if(index == (this.patients.length - 1) && event.keyCode == 9 && event.shiftKey == false){
      event.preventDefault();
      this.$refs.listIndexes[index].focus();
      return false;

    }
    else if (index == 0 && event.keyCode == 9 && event.shiftKey == true ){
      this.patients = [];
    }
  },
  keyupMethod(index){
    if(event.keyCode == 27){
      this.selectedSearchOption = true;
    }
  },
  searchListClicked(item){
    this.selectedSearchOption = true;
    this.form.name = item.name;
    this.form.fatherName = item.fatherName;
    this.form.address = item.address;
    this.form.phoneNumber = item.phone;
    this.form.id = item.id;
    this.patients = [];

  },
},

created () {
},
destroyed () {
},


}

</script>

<style media="screen">
  .danger,
  .danger .dropdown-toggle,
  .danger .selected-tag {
    color: #f86c6b;
    border-color: #f86c6b;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f86c6b' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f86c6b' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    background-position: right calc(0.375em + 0.95rem) center;
  }
  .danger-span{
    width:100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f86c6b;

  }

  .borderCard{
    border: 1px solid #e3e8ec;
  }
</style>
